export default __webpack_public_path__ + "static/media/ev-illustration.661fb097.svg";